// Analytics is opt-in per tenant. A user is only tracked when the client_id claim in
// their token appears in the configured allowlist, so an empty list collects nothing
// anywhere, and a user with no tenant is never tracked.
export function isClientAllowed(clientId: string | undefined, allowlist: string[]): boolean {
  if (!clientId || allowlist.length === 0) {
    return false
  }
  return allowlist.includes(clientId.trim().toLowerCase())
}
